import React, { Component } from "react";
import './Music-List.css';
import MusicList from "./Music-List";
import { Link } from 'react-router-dom';
import axios from '../tokenInterceptor';
// import axios from 'axios';
import Slider from "react-slick";
import Loader from "react-loader-spinner";
import PlaySongs from "./PlaySongs";

function SampleNextArrow(props) {
    const { style, onClick } = props;
    return (
        <div
            className={"slick-next"}
            style={{
                ...style,
                top: "40%",
                display: "block",
                width: "20px",
                height: "20px",
            }}
            onClick={onClick}
        >
            <i className="fa fa-angle-right fa-2x" />
        </div>
    );
}

function SamplePrevArrow(props) {
    const { style, onClick } = props;
    return (
        <div
            className={"slick-prev"}
            style={{
                ...style,
                top: "40%",
                display: "block",
                width: "20px",
                height: "20px",
            }}
            onClick={onClick}
        >
            <i className="fa fa-angle-left fa-2x" />
        </div>
    );
}

class Home extends Component {
    constructor(props) {
        super(props);
        this.state={
            popularMusicList:{
                "popular_tracks_desc":{
                    "itemLabel":"",
                    "image":{
                        "uri": "",
                        "width": 250,
                        "height": 250,
                    }
                },
                "popular_albums_desc":{
                    "itemLabel":"",
                    "image":{
                        "uri": "",
                        "width": 250,
                        "height": 250,
                    }
                },
                "popular_playlists_desc":{
                    "itemLabel":"",
                    "image":{
                        "uri": "",
                        "width": 250,
                        "height": 250,
                    }
                },
                "popular_stations_desc":{
                    "itemLabel":"",
                    "image":{
                        "uri": "",
                        "width": 250,
                        "height": 250,
                    }
                }
            },
            topSongsTracks:[],
            topAlbumsTracks:[],
            topPlaylistsTracks:[],
            topStationsTracks:[],
            loader:true,
            selectedMusic:{}
        }
    }

    componentWillMount=()=>{
        // localStorage.setItem('auth-token', "Atza|IwEBIPDB-8Y26vaWwWdjm11e4-TfiBMt51O-STxTWhA5j_2x07XR9Ay5zq94ruciRrSbhi9I8OsVAMnQMdX1NSzyYQTNDqi39U4zc0da5Xe0iGw1DMQ34ZEuGU2CNw0NOlSm_cTrrjXAT4xXVB3LiP5oiRN_t_EXElyBFFTEujs_51IMejM344kI0bPo5lxNb3l4sHf-AAtPKbGwiD_3ypm_KaThrH2ATk2_n9p2EVKQ2SMsxyTm8CKjBtsawNwoPx7-G0eHPyS4Qpbq7lePBc5_YqzYaGDMpm4WKlqsgUcTNAR-3D08-O5VxQf106ueYsig-Rm2YbvlK4s0mM3BBJjikYC3rHCrVGBsFflvMOrAfsjJS8DtchWeez3qIKRA10-6_jKfxfiAqfzB1B6zY1_ULlmTg7IpFDiXmcJj4bbBwAFWenmj0evhzxy551rkrQt-HKFoqXJ0xdtZH41DH_bzN4pKhcDKNn9FATfFqbOnziJud5SOHBgNgerfnqvno_ckDtCmPb8xZIywbWBTldstUULI35iGzLH173rES5_zmXXYtqIaGI1VPrviuhiEcZcmJ-E");
        // localStorage.setItem('expire', 3600);
        // localStorage.setItem('tokenFetchTime', 1559056844551);
        // localStorage.setItem('refresh_token', "Atzr|IwEBIB7VoeRp3eZBDqnsuTuDYjBbcs-zYe27-Ov724ozIEqgcKuw0ZvfElrXA-G76GRhKqkn0IaqekW40MBoSuLA7j1hApGO2H4xySGtiA6jVQjdUU_LlE9d0j4ZpykNKVkc9O3d5yY8dIfJaCXDDCdzb5D9cJEcNshFlhruD-h6tL8hq0IrtPtTPWFHJu2w-JKpnmU8OGAwUf0JpU3NtAHFM8QrXgKaTp_a0DMyrqXLx4_Sbc3XBXxKXGEyZvXgIG12ual3X2iaHqhnx9M6SjQwxUyxcKU4lboNM3-h3sYcGlPrlEuPaTGNP3uvd6nyiSw_pXg6AGspxDENVbtmaGM15lVymdAlJ57BGXbA0-srzX-2BoQonA272M51Bi3Uz9-p-7uD-ejyyRvQya5-W8SujDOBtd7bl6_JFHgt5NTdq9L34V4uqtMc8gJMg4YwY4ey5Rffsz5hXYzTV5weRcU0Wa6tbCehouYGR2cumEl3RNRNZNiPTF5kR8gKyHMp3Ry7KDLrsX_2ZkwEXRaspF7PWtk_");
        this.checkTokenExpire();
    }

    getMostPopularList =()=>{

        let basicToken  = localStorage.getItem("auth-token");
        
        let config = {
            headers: {
               'Authorization': 'Bearer '+basicToken,
            }
        };

        console.log('Inside getMostPopularList',basicToken);

        // let amazonMusicApi ='https://music-api.amazon.com'
        let amazonMusicApi = 'https://external.us-east-1.gamma.api.music.a2z.com';

        if (window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('127.0.0.1') > -1) {
            amazonMusicApi ='https://external.us-east-1.gamma.api.music.a2z.com';
        }

        axios.get(`${amazonMusicApi}/catalog/popular/tracks/`,{
            headers:{
                //'Cache-Control': 'no-cache',
                Accept: 'application/json',
                Authorization:basicToken
            }
            }
        ).then(res=>{
            console.log('get the data',res);
            if(res.status === 200) {
                this.setState({popularMusicList:{itemDescriptions:res.data.itemDescriptions,trackDefinitions:res.data.trackDefinitions}, loader:false});
                // this.getTopSongsList();
                // this.getTopAlbumsList();
                // this.getTopPlaylists();
                // this.getTopStations();
                // this.props.history.push('/music-list');
            } else {
                this.setState({popularMusicList:{}});
            }
        })
    }

    // getTopSongsList =()=>{
    //     axios.get("https://external.us-east-1.gamma.api.music.a2z.com/catalog/popular/tracks/").then((res)=>{
    //         console.log('Top Song list', res)
    //         if(res.data.status == 200) {
    //             let td = res.data.data.trackDefinitions;
    //             let num = Object.keys(td).length;
    //             let topSongsContents =[]
    //             for(let i=0; i<num; i++) {
    //             let key = "track_def_"+i;
    //             let data = td[key];
    //             topSongsContents.push(data);
    //             };
    //             this.setState({topSongsTracks:topSongsContents});
    //         } else {
    //             this.setState({topAlbumsTracks:[]});
    //         }
    //     })
    //
    // }
    //
    // getTopAlbumsList =()=>{
    //     axios.get("/getTopAlbumsTracks").then((res)=>{
    //         if(res.data.status == 200) {
    //             let td = res.data.data.itemDescriptions;
    //             let num = Object.keys(td).length;
    //             let topAlbumContents =[]
    //             for(let i=0; i<num; i++) {
    //             let key = "album_"+i+"_desc";
    //             let data = td[key];
    //             topAlbumContents.push(data);
    //             };
    //             this.setState({topAlbumsTracks:topAlbumContents});
    //         } else {
    //             this.setState({topAlbumsTracks:[]});
    //         }
    //     })
    // }
    //
    // getTopPlaylists =()=>{
    //     axios.get("/getTopPlaylistsTracks").then((res)=>{
    //         if(res.data.status == 200) {
    //             let td = res.data.data.itemDescriptions;
    //             let num = Object.keys(td).length;
    //             let topPlaylistsContents =[]
    //             for(let i=0; i<num; i++) {
    //             let key = "playlist_"+i+"_desc";
    //             let data = td[key];
    //             topPlaylistsContents.push(data);
    //             };
    //             this.setState({topPlaylistsTracks:topPlaylistsContents});
    //         } else {
    //             this.setState({topPlaylistsTracks:[]});
    //         }
    //     })
    // }
    //
    // getTopStations =()=>{
    //     axios.get("/getTopStationsTracks").then((res)=>{
    //         if(res.data.status == 200) {
    //             let td = res.data.data.itemDescriptions;
    //             let num = Object.keys(td).length;
    //             let topPlaylistsContents =[]
    //             for(let i=0; i<num; i++) {
    //             let key = "station_"+i+"_desc";
    //             let data = td[key];
    //             topPlaylistsContents.push(data);
    //             };
    //             this.setState({topStationsTracks:topPlaylistsContents});
    //         } else {
    //             this.setState({topStationsTracks:[]});
    //         }
    //     })
    // }
    //
    setMusic=(data)=>{
        let selectedMusic= this.state.selectedMusic;
        selectedMusic.title = data.album.name;
        selectedMusic.artist = data.artist.name;
        // selectedMusic.imageUrl = data.image.uri;
        selectedMusic.songUrl = data.audio.uri;
        this.setState({selectedMusic:selectedMusic});
    }

    generateNewAccessToken() {
        console.log("rfresh token =====", localStorage.getItem("refresh_token"))
        var requestObject = {
          "grant_type": "client_credentials", //"refresh_token",
            "scope": "music",
            "refresh_token": localStorage.getItem("refresh_token"),
          "client_id": "amzn1.application-oa2-client.be6fd65f44a24c7dabec6f1e78c0fbd9",
          "client_secret": "9ceb5c037d0d032d62fd09e64b4784dfd06ec22cae72e15cb9b9e1690e3bfe05"
        };
        axios.post("generateToken", requestObject).then((res)=>{
            if(res.status === 200) {
                console.log("responsereceived == ", res);
                var currentTime   = new Date();
                this.tokenGetTime=  currentTime.getTime();
                localStorage.setItem('auth-token', res.data.access_token);
                localStorage.setItem('expire', 3600);
                localStorage.setItem('tokenFetchTime', this.tokenGetTime);
                localStorage.setItem('refresh_token', res.data.data.refresh_token);
                this.getMostPopularList();
            } else {
                console.log("unable to generate token");
            }
        });
    }

    checkTokenExpire=()=>{
        var currentTime   = new Date();
        this.tokenGetTime=  localStorage.getItem('tokenFetchTime');
        if((currentTime.getTime() - this.tokenGetTime)/1000 < 3600) {
            console.log('checkTokenExpire = false, calling getMostPopular');
            this.getMostPopularList();
        } else {
            console.log('checkTokenExpire = true, calling generateNewAccessToken')
            this.generateNewAccessToken();
        }
    }

    render() {
        const settings = {
            infinite: true,
            speed: 700,
            slidesToShow: 4,
            dots: false,
            slidesToScroll: 4,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };
        console.log(this.state)
        return (
            <>
                {this.state.loader ? <div className="overlay">
                        <div className="loader">
                            <Loader type="Bars" color="#60b6e0" height="100" width="100" />
                        </div>
                    </div> :
                    <>
                        <div className="right-section">
                            <div className="main-page">
                                <div className="top-songs">

                                    <h3 className="heading">{"Polpular Music"}</h3>
                                    <hr/>
                                    <ul>
                                        {Object.values(this.state.popularMusicList.itemDescriptions).map((data, index)=>{
                                             return <li key={index} className="song-title">
                                                <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title" style={{"cursor": "pointer"}}
                                                   onClick={()=>this.setMusic(this.state.popularMusicList.trackDefinitions[`track_def_${index}`])}>{data.itemLabel}</a>
                                            </li>
                                        })}
                                    </ul>
                                </div>
                               {/*<playSongs/>*/}
                                {/*<div className="top-albums">*/}
                                {/*    <h3 className="heading">{this.state.popularMusicList.track_1_desc.itemLabel}</h3>*/}
                                {/*    <hr/>*/}
                                {/*    <Slider {...settings}>*/}
                                        {/*{*/}
                                        {/*    this.state.topAlbumsTracks.map((data, index)=>{*/}
                                        {/*    return<div className="p-2" key={index}>*/}
                                        {/*            <img src={data.image.uri} alt="connect-img" className="img-fluid rounded slider_img" style={{"width":"150px", "height":"150px"}}/>*/}
                                        {/*        </div>*/}
                                        {/*    })*/}
                                        {/*}*/}
                                    {/*    <div className={"p-2"}>*/}
                                    {/*        <img src={this.state.popularMusicList.track_1_desc.image.uri} alt="connect-img" className="img-fluid rounded slider_img" style={{"width":"150px", "height":"150px"}}/>*/}
                                    {/*    </div>*/}
                                    {/*</Slider>*/}
                                {/*</div>*/}
                                {/*<div className="top-playlist">*/}
                                {/*    <h3 className="heading">{this.state.popularMusicList.track_2_desc.itemLabel}</h3>*/}
                                {/*    <hr/>*/}
                                {/*    <Slider {...settings}>*/}
                                        {/*{*/}
                                        {/*    this.state.topPlaylistsTracks.map((data, index)=>{*/}
                                        {/*    return<div className="p-2" key={index}>*/}
                                        {/*            <img src={data.image.uri} alt="connect-img" className="img-fluid rounded slider_img" style={{"width":"150px", "height":"150px"}}/>*/}

                                        {/*        </div>*/}
                                        {/*    })*/}
                                        {/*}*/}
                                    {/*</Slider>*/}
                                {/*</div>*/}
                                {/*<div className="top-stations">*/}
                                {/*    <h3 className="heading">{this.state.popularMusicList.track_3_desc.itemLabel}</h3>*/}
                                {/*    <hr/>*/}
                                    {/*<Slider {...settings}>*/}
                                    {/*    {*/}
                                    {/*        this.state.topStationsTracks.map((data, index)=>{*/}
                                    {/*        return<div className="p-2" key={index}>*/}
                                    {/*                <img src={data.image.uri} alt="connect-img" className="img-fluid rounded slider_img" style={{"width":"150px", "height":"150px"}}/>*/}
                                    {/*            </div>*/}
                                    {/*        })*/}
                                    {/*    }*/}
                                    {/*</Slider>*/}
                                {/*</div>*/}
                                <PlaySongs
                                    music={this.state.selectedMusic}
                                />
                            </div>
                        </div>

                    </>
                }
            </>
            
        )
    }
}

export default Home;
